//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  methods: {
    handleClick: function handleClick(vm, event) {
      this.$message({
        message: "\u4F60\u70B9\u51FB\u4E86".concat(vm.$slots.default[0].text),
        type: 'info'
      });
    }
  }
};